<template>
	<ul class="card-list">
	<div v-if="$breakpoints.isMobile()"> 
		<swiper :options="swiperOption">
			<li v-if="stack" v-bind:stack="stack" class="card stack swiper-slide">
				<h2 class="stack-title">{{stack.title}}</h2>
				<p class="stack-why">{{stack.description}}</p>

				<div class="stack-meta">
					<p><a href="javascript:void(0)" v-on:click.stop="stackModal">
				stacks ({{stackNumber}}) | <span v-if="stack.cards">{{stack.cardCount}}</span><span v-else>0</span> cards curated by {{stack.username}}
		</a></p>
				</div>
			</li>
			<create-card-form class="swiper-slide" :user="user" :stack="stack" v-if="user"></create-card-form>
			<card class="swiper-slide" v-if="stack.cards"
		      v-for="(card, index) in cards"
		      :card="card" :stack="stack" :user="user" :index="index" :key="card.key"
		      >
		    </card>
		    <div class="swiper-button-prev" slot="button-prev"></div>
		    <div class="swiper-button-next" slot="button-next"></div>
		    <div class="swiper-pagination" slot="pagination"></div>
	    </swiper>
	</div>
	<div v-else>
		<li v-if="stack" v-bind:stack="stack" class="card stack">
			<div class="card-actions">
				<button type="button" @click.stop="stackModal" v-if="user">edit stacks</button>
			</div>
			<h2 class="stack-title">{{stack.title}}</h2>
			<p class="stack-why">{{stack.description}}</p>

			<div class="stack-meta">
				<p><a href="javascript:void(0)" v-on:click.stop="stackModal">
				stacks ({{stackNumber}}) | <span v-if="stack.cards">{{stack.cardCount}}</span><span v-else>0</span> cards curated by {{stack.username}}
		</a></p>
			</div>
		</li>
		<create-card-form :user="user" :stack="stack" v-if="user"></create-card-form>
		<card v-if="stack.cards"
		      v-for="(card, index) in cards"
		      :card="card" :stack="stack" :user="user" :index="index" :key="card.key"
		      >
		</card>
	</div>



	    


	     
			    
			
			
		<update-modal></update-modal>
	    <stack-modal :user="user"></stack-modal>
	</ul>

</template>

<script>
import Card from '../cards/Card'
import * as firebase from "firebase";
import firebaseApp from  "../../data/FirebaseApp";
import cardRepository from '../../data/CardRepository'
import stackFunctions from '../../data/stackFunctions'
import UpdateModal from '../cards/UpdateModal'
import StackModal from '../cards/StackModal'
import EventBus from '../EventBus'
import CreateCardForm from '../cards/Create'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

var database = firebase.database()

export default {
	props: ['user'],
	data() {
		return {
			cards:[],
			stack: null,
			loadStack: true,
			stackRef: null,
			stackKeyLoaded: false,
			stackCardCount: null,
			stackNumber: 0,
			swiperOption: {
	        	nextButton: '.swiper-button-next',
	        	prevButton: '.swiper-button-prev',
	        	pagination: '.swiper-pagination',
	        	paginationType: 'progress',
	        	paginationClickable: true,
	        	slidesPerView: 4,
	        	slidesPerGroup:4,
	        	spaceBetween: 15,
	          	breakpoints: {
	            	1024: {
	                	slidesPerView: 3,
	                	slidesPerGroup:3,
	              	},
	              	768: {
	                	slidesPerView: 2,
	                	slidesPerGroup:2,
	              	},
	              	600: {
	              		slidesPerView: 1,
	              		slidesPerGroup:1,
	              	},
	            }
			},	
		}
	},
	watch: {
		stackKeyLoaded: function() {
			this.getCards()
			this.removeCard()
			
		},
	},
	components: {
		Card,
		UpdateModal,
    	StackModal,
    	CreateCardForm,
    	swiper,
    	swiperSlide
	},
	computed: {	
	},
	created() {
	},
	methods: {
		getCards: function(){

			var that = this

			firebase.database().ref('stacks/' + this.stack.key + '/cards').orderByChild("order").on('child_added', function(snapshot){

				var cardKey = snapshot.key
				firebase.database().ref('cards/' + cardKey).once('value').then(function(snapshot){
					
					var card = snapshot.val()
					if(card) { //so wouldn't trigger error if card deleted
						card.key = cardKey
						
						firebase.database().ref('users/' + card.creator + '/username').once('value').then(function(snapshot){
						    card.username = snapshot.val()
						    that.cards.push(card);
						    if(that.loadStack){
						    	EventBus.$emit('loaded')
						    	that.loadStack = false
						    }   
						})    
					}
				})
			})

		},
		removeCard: function() {
			var that = this
			firebase.database().ref('stacks/' + this.stack.key + '/cards').on('child_removed', function(snapshot){
				let cardToRemove = cardRepository.findIndex(that.cards, snapshot.key)
				that.cards.splice(cardToRemove, 1)
			})
		},
		stackModal() {
			EventBus.$emit('stack.addStack', this.stack)
		}
	},
	mounted() {

		this.stackRef = database.ref("stacks").orderByChild('slug').equalTo(this.$route.params.slug)
		var that = this
		this.stackRef.on('value', function(snapshot) {
			var foundStack = snapshot.val()
			var stackkey = Object.keys(foundStack)
			that.stack = foundStack[stackkey]
			that.stack.key = stackkey[0]
			that.stackKeyLoaded = true;
			that.stackCardCount = that.stack.cardCount
			if(that.stack.cardCount == null || that.stack.cardCount == 0){
				EventBus.$emit('loaded')
			}
			var userRef = firebase.database().ref("users/" + that.stack.creator + '/username')
			userRef.once('value').then(function(snapshot){
				that.stack.username = snapshot.val()
			})

			//we need this so when stack is edited, we know which card it is bound to
			var boundCardRef = firebase.database().ref("cards/" + that.stack.boundCard)
			boundCardRef.once('value').then(function(snapshot){
				that.stack.boundCardObj = snapshot.val()
				if(that.stack.boundCardObj.stacks){
					that.stackNumber = that.stack.boundCardObj.stackCount
				}
				
			})



		});
	

	},
	beforeDestroy() {
    	stackFunctions.detachFirebaseListeners()
    	cardRepository.detachFirebaseListeners()
    	this.stackRef.off()
    	

  	}
}
</script>


// WEBPACK FOOTER //
// Stack.vue?7b455e06